import { render, staticRenderFns } from "./LocationPreferences.vue?vue&type=template&id=c1c9bb8c&"
import script from "./LocationPreferences.vue?vue&type=script&lang=js&"
export * from "./LocationPreferences.vue?vue&type=script&lang=js&"
import style0 from "./LocationPreferences.vue?vue&type=style&index=0&id=c1c9bb8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports